/**
 * Woocommerce: Dimensions Feedback
 *
 * Give feedback on the values entered
 * in the width and length
 *
 * @since 1.0.0
 */

import { dimensionsFeedback } from './DimensionsValidation'

export default () => {
  // Grab all necessary elements
  const cartForm = document.querySelector('form.cart')
  if (!cartForm) return

  const widthInput = cartForm.querySelector('.js-woo-width')
  const lengthInput = cartForm.querySelector('.js-woo-length')
  const diameterInput = cartForm.querySelector('.js-woo-diameter')
  const rubberRadios = cartForm.querySelectorAll('.js-woo-rubber')
  const feedbackField = cartForm.querySelector('.js-woo-dimensions-feedback')

  if (!widthInput || !lengthInput || !feedbackField) {
    return
  }

  // Standard values
  let message = ''
  let width = 0
  let length = 0
  let diameter = 0
  let hasRubber = 0
  let timer = 0

  // Increase max dimension if user has checked rubber_edge
  if (rubberRadios)
    [...rubberRadios].map(rubberRadio => {
      rubberRadio.addEventListener('change', e => {
        hasRubber = e.target.value === '1' && e.target.checked ? 1 : 0
        message = dimensionsFeedback(width, length, hasRubber, cartForm)
        feedbackField.innerHTML = message
      })
    })

  // Change feedback based on width value
  widthInput.addEventListener('input', e => {
    width = e.target.value
    clearTimeout(timer)

    // Wait for user to finish typing
    timer = setTimeout(() => {
      // Determine validation message
      message = dimensionsFeedback(width, length, hasRubber, cartForm)

      if (!width) {
        // Validate empty length
        message = 'Voer het gewenste formaat in.'
      }

      feedbackField.innerHTML = message
    }, 500)
  })

  // Change feedback based on length value
  lengthInput.addEventListener('input', e => {
    length = e.target.value
    clearTimeout(timer)

    // Wait for user to finish typing
    timer = setTimeout(() => {
      // Determine validation message
      message = dimensionsFeedback(width, length, hasRubber, cartForm)

      if (!length) {
        // Validate empty length
        message = 'Voer het gewenste formaat in.'
      }

      feedbackField.innerHTML = message
    }, 500)
  })

  // Change feedback based on width value
  if (diameterInput) {
    diameterInput.addEventListener('input', e => {
      width = e.target.value
      length = e.target.value
      diameter = e.target.value
      widthInput.value = width
      lengthInput.value = length
      clearTimeout(timer)

      // Wait for user to finish typing
      timer = setTimeout(() => {
        // Determine validation message
        message = dimensionsFeedback(
          width,
          length,
          hasRubber,
          cartForm,
          diameter
        )

        if (!diameter) {
          // Validate empty length
          message = 'Voer het gewenste formaat in.'
        }

        feedbackField.innerHTML = message
      }, 500)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/woocommerce/DimensionsFeedback.js